import validate from "/usr/src/app/content/n3-promos-01a8504a-0636-42bf-add8-07e57eac5003/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-promos-01a8504a-0636-42bf-add8-07e57eac5003/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}